export default __webpack_public_path__ + "static/media/insta21.62e98cbc.webp";